import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const flexiComboCreateRolesRBAC = {
  pageID: '6657526b5186498913bebf1cabd400e9',
  elementID: {
    ButtonSave: '85f71ca4d785816e5ba9318e1cd4826b',
    ButtonBulkUpload: '65c8ca0a3d388f11ac7c53446d08750e',
    ButtonChooseProduct: 'b1c7b97cb3d15e24085fd5890a769ba0',
  },
} as const

export const useRBACFlexiComboCreatePage = createUseRBAC(flexiComboCreateRolesRBAC.elementID)

export type UseRBACFlexiComboCreatePageType = ReturnType<typeof useRBACFlexiComboCreatePage>

export const flexiComboEditRolesRBAC = {
  pageID: '1edd792562459227a5ee14258e3f243d',
  elementID: {
    ButtonSave: '284cc348ca4225091ee6c77216db89c7',
    ButtonBulkUpload: '2fc0d5853d5b4c2c1cdc5c978342e7b2',
    ButtonChooseProduct: '23fc8e8bd7443e62bb6d8f8424d6ecd4',
  },
} as const

export const useRBACFlexiComboEditPage = createUseRBAC(flexiComboEditRolesRBAC.elementID)

export type UseRBACFlexiComboEditPageType = ReturnType<typeof useRBACFlexiComboEditPage>
